import React from 'react';
import "./styles/app.scss";
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import RouteAuthorizer from './views/components/RouteAuthorizer';
import { UserStateProvider } from './views/components/Mode';

// Pages
import Login from './pages/Login';
import Home from './pages/Home';
import ResetPassword from './pages/reset-password/ResetPassword';
import NewPassword from './pages/reset-password/NewPassword';
import SingleHistory from './pages/history/SingleHistory';
import UserAccounts from './pages/user-accounts/UserAccounts';
import AddUser from './pages/user-accounts/AddUser';
import History from './pages/history/History';
import Register from './pages/Register';
import Feedback from './pages/feedback/Feedback';
import InformTheBot from './pages/InformTheBot';
import SingleFeedback from './pages/feedback/SingleFeedback';
import HelpRequests from './pages/help-requests/HelpRequests';
import SingleUser from './pages/user-accounts/SingleUser';
import ChangePassword from './pages/user-accounts/ChangePassword';
import SingleHelpRequest from './pages/help-requests/SingleHelpRequest';
import Documents from './pages/Documents';
import BotSettings from './pages/BotSettings';
import Search from './pages/Search';

const router = createBrowserRouter([
  {
    path: "/",
    element: <RouteAuthorizer element={ <Login /> } />,
  },
  {
    path: "/register/:key",
    element: <RouteAuthorizer element={ <Register /> } />,
  },
  {
    path: "/reset-password",
    element: <RouteAuthorizer element={ <ResetPassword /> } />,
  },
  {
    path: "/reset-password/:key",
    element: <RouteAuthorizer element={ <NewPassword /> } />,
  },
  {
    path: "/home",
    element: <RouteAuthorizer element={ <Home /> } requireAuth />,
  },
  {
    path: "/history",
    element: <RouteAuthorizer element={ <History /> } requireAuth />,
  },
  {
    path: "/history/page/:page",
    element: <RouteAuthorizer element={ <History /> } requireAuth />,
  },
  {
    path: "/feedback",
    element: <RouteAuthorizer element={ <Feedback /> } requireAuth />,
  },
  {
    path: "/feedback/page/:page",
    element: <RouteAuthorizer element={ <Feedback /> } requireAuth />,
  },
  {
    path: "/feedback/:id",
    element: <RouteAuthorizer element={ <SingleFeedback /> } requireAuth />,
  },
  {
    path: "/feedback/page/:page/:rating",
    element: <RouteAuthorizer element={ <Feedback /> } requireAuth />,
  },
  {
    path: "/help-requests",
    element: <RouteAuthorizer element={ <HelpRequests /> } requireAuth />,
  },
  {
    path: "/help-requests/:id",
    element: <RouteAuthorizer element={ <SingleHelpRequest /> } requireAuth />,
  },
  {
    path: "/help-requests/page/:page/:status",
    element: <RouteAuthorizer element={ <HelpRequests /> } requireAuth />,
  },
  {
    path: "/inform-the-bot",
    element: <RouteAuthorizer element={ <InformTheBot/> } requireAuth capability="read_inform_the_bot" />,
  },
  {
    path: "/inform-the-bot/page/:page",
    element: <RouteAuthorizer element={ <InformTheBot /> } requireAuth capability="read_inform_the_bot" />,
  },
  {
    path: "/user-accounts",
    element: <RouteAuthorizer element={ <UserAccounts /> } requireAuth capability="read_user_accounts" />,
  },
  {
    path: "/user-accounts/page/:page",
    element: <RouteAuthorizer element={ <UserAccounts /> } requireAuth capability="read_user_accounts" />,
  },
  {
    path: "/history/:sessionId",
    element: <RouteAuthorizer element={ <SingleHistory/> } requireAuth />,
  },
  {
    path: "/user-accounts/add",
    element: <RouteAuthorizer element={ <AddUser /> } requireAuth capability="create_user" />,
  },
  {
    path: "/user-accounts/:id",
    element: <RouteAuthorizer element={ <SingleUser /> } requireAuth />,
  },
  {
    path: "/user-accounts/:id/change-password",
    element: <RouteAuthorizer element={ <ChangePassword /> } requireAuth user />,
  },
  {
    path: "/documents",
    element: <RouteAuthorizer element={ <Documents /> } requireAuth capability="read_documents" />,
  },
  {
    path: "/documents/page/:page",
    element: <RouteAuthorizer element={ <Documents /> } requireAuth capability="read_documents" />,
  },
  {
    path: "/bot-settings",
    element: <RouteAuthorizer element={ <BotSettings /> } requireAuth />,
  },
  {
    path: "/search/:query/page/:page",
    element: <RouteAuthorizer element={ <Search /> } requireAuth />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserStateProvider>
      <RouterProvider router={ router } />
    </UserStateProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
